import React from 'react'
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css'
import 'leaflet-defaulticon-compatibility'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

export default function AccessMap(props) {
  const MAPBOX_API_KEY = process.env.GATSBY_MAPBOX_API_KEY
  const isBrowser = typeof window !== 'undefined'

  return (
    <div style={{ height: '500px' }}>
      {isBrowser && (
        <MapContainer
          center={[props.location.lat, props.location.lon]}
          zoom={8}
          scrollWheelZoom={false}
          style={{ height: '100%', width: '100%' }}
        >
          <TileLayer
            url={`https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/256/{z}/{x}/{y}@2x?access_token=${MAPBOX_API_KEY}`}
            attribution='Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery &copy; <a href="https://www.mapbox.com/">Mapbox</a>'
          />
          <Marker position={props.location} draggable={false}>
            <Popup>{props.title}</Popup>
          </Marker>
        </MapContainer>
      )}
    </div>
  )
}

AccessMap.propTypes = {
  location: PropTypes.shape({
    lat: PropTypes.number,
    lon: PropTypes.number,
  }),
  title: PropTypes.string,
}

export const query = graphql`
  fragment AccessPlanFragment on ContentfulWidgetPlanDacces {
    __typename
    id: contentful_id
    location {
      lat
      lon
    }
    title
  }
`
